import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import BreadcrumbBasic from '@s-ui/react-molecule-breadcrumb'
import IconAngleRight from '@adv-mt/mt-svg-icons/lib/AngleRight'

const getIcon = () => (
  <div className="mt-NavigationBreadcrumb-icon">
    <IconAngleRight />
  </div>
)

const NavigationBreadcrumb = ({items = [], linkFactory, className = ''}) => {
  const {i18n} = useContext(Context)
  const breadcrumbs = items.map(breadcrumb => {
    const {label, params} = breadcrumb
    return {
      ...breadcrumb,
      label: i18n.t(label, {...params})
    }
  })

  const baseClassName = cx('mt-NavigationBreadcrumb', className)

  return (
    <div className={baseClassName}>
      <BreadcrumbBasic
        aria-label={i18n.t('COMMON.BREADCRUMB.ARIA_LABEL')}
        items={breadcrumbs}
        icon={getIcon}
        linkFactory={linkFactory}
        isScrollable
        className={`${baseClassName}-content`}
      />
    </div>
  )
}

NavigationBreadcrumb.displayName = 'NavigationBreadcrumb'

NavigationBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      params: PropTypes.object,
      url: PropTypes.string
    })
  ),
  linkFactory: PropTypes.func,
  className: PropTypes.string
}

export default NavigationBreadcrumb
